import {JsToClientCommand} from '../jsToClientCommand';
import {ClientCommands} from '../clientCommands';

export type SetConsetResultParams = {
    consent: boolean
};


export class SetConsentResultCommand extends JsToClientCommand<SetConsetResultParams> {
    constructor(params: SetConsetResultParams) {
        super(ClientCommands.SET_CONSENT_RESULT, {
            // @ts-ignore
            // eslint-disable-next-line no-nested-ternary
            consent: params.consent === null ? 0 : params.consent ? 1 : 2
        });
    }
}
